import { getLocalizedStringStore } from './store/store';
import { format } from './utilities/format';
import { orchestrator } from 'satcheljs';
import { addLocstringsToStore } from './actions/addLocstringsToStore';

export function loc(resourceId: string, ...args: any[]) {
    const locString =
        process.env.NODE_ENV === 'dev'
            ? resourceId
            : getLocalizedStringStore().localizedStrings.get(resourceId) || '';
    return args.length ? format(locString, ...args) : locString;
}

const unresolvedStringRequests: Record<string, ((localizedString: string) => void)[]> = {};

/**
 * This function returns a Promise that is guaranteed to resolve with the actual localized string,
 * rather than returning an empty string if the string is not yet loaded. This is primarily intended
 * for GraphQL resolvers, not for observable components that can re-render when a string is loaded.
 */
export function getPromiseForLocalizedString(resourceId: string): Promise<string> {
    if (process.env.NODE_ENV === 'dev') {
        return Promise.resolve(resourceId);
    }

    if (getLocalizedStringStore().localizedStrings.has(resourceId)) {
        return Promise.resolve(getLocalizedStringStore().localizedStrings.get(resourceId)!);
    } else {
        return new Promise<string>(resolve => {
            unresolvedStringRequests[resourceId] = unresolvedStringRequests[resourceId] ?? [];
            unresolvedStringRequests[resourceId].push(resolve);
        });
    }
}

orchestrator(addLocstringsToStore, actionMessage => {
    for (const resourceId of Object.keys(actionMessage.str)) {
        if (unresolvedStringRequests[resourceId]) {
            for (const callback of unresolvedStringRequests[resourceId]) {
                callback(actionMessage.str[resourceId]);
            }
            delete unresolvedStringRequests[resourceId];
        }
    }
});
